// src/utils/imperativeFormIII_salim.js
// בניין 3 (يُفَاعِلُ) - צורות הציווי לגזרת השלמים

const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F]/g;

const stripHarakat = s => (s || '').replace(HARAKAT_RE, '');

function getRootLetters(row) {
  const root = stripHarakat((row['שורש'] || row['root'] || '').trim());
  const letters = root.replace(/[^\u0621-\u064A]/g, '');
  if (letters.length !== 3) return null;
  return [letters[0], letters[1], letters[2]];
}

export function buildImperativeFormIII_Salim(row) {
  const R = getRootLetters(row);
  if (!R) return null;
  const [R1, R2, R3] = R;
  const isNunEnding = R3 === 'ن';

  const stem = R1 + FATHA + 'ا' + R2 + KASRA + R3;

  return {
    you_ms: stem + SUKUN,
    you_fs: stem + KASRA + 'ي',
    you_mp: stem + DAMMA + 'وا',
    you_fp: isNunEnding ? stem + SHADDA + FATHA : stem + SUKUN + 'نَ',
  };
}

export function buildImperativeFromRowIII(row) {
  const binyan = (row['בניין'] || '').trim();
  const gizra = (row['gizra'] || '').trim();
  if (!(binyan === '3' || binyan === 'בניין 3')) return null;
  const gizraOk = gizra.includes('שלמים') || gizra.includes('ע"ו') || gizra.includes('פ"ו');
  if (!gizraOk) return null;
  return buildImperativeFormIII_Salim(row);
}
